module.exports = __webpack_public_path__ + "img/bg.22cccda2.jpg";